import { motion } from "framer-motion";
import Image from "next/image";
import img1 from "../../public/images/4.webp";

export default function BecomeCounsellor() {
  return (
    <section className="pt-16 sm:py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12 lg:ml-24">
          {/* Image Section */}
          <div className="flex-1">
            <Image
              src={img1}
              alt="Counsellor Image"
              className=""
              width={600}
              height={500}
            />
          </div>

          {/* Text Section */}
          <div className="flex-1  lg:text-left">
            <h3 className="text-2xl font-semibold text-gray-800">
              Become a Counsellor
            </h3>
            <p className="mt-4 text-gray-600 leading-relaxed">
              Join our Community and Lead the Way—Support Students in Achieving
              Their Medical Dreams
            </p>
            <div className="mt-6">
              <a
                href="/contact"
                className="inline-block px-6 py-2 border border-orange-500 text-orange-500 rounded-full font-medium hover:bg-orange-500 hover:text-white transition"
              >
                Apply Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
